import type { DragState } from './types';

export const idleState: DragState = { type: 'idle' };
export const draggingState: DragState = { type: 'dragging' };
